// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__ku98w","consentsList":"PatientConsents_consentsList__2PSy9","consentsListEmpty":"PatientConsents_consentsListEmpty__AKXea"};